package co.maytes.standupbot.dashboard.pages.app.standups.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.FormRow
import co.maytes.standupbot.dashboard.components.widgets.SectionCard
import co.maytes.standupbot.dashboard.components.widgets.TextInput
import co.maytes.standupbot.dashboard.features.standups.MeetingLinkForm
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.shared.dto.standup.StandupDto
import co.maytes.standupbot.shared.dto.standup.UpdateStandupRequestDto
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import org.jetbrains.compose.web.attributes.InputType

@Composable
internal fun MeetingLinkCard(
    standup: StandupDto,
    inFlight: Boolean,
    onSave: (UpdateStandupRequestDto) -> Unit,
) {
    var draft by remember(standup.id, standup.meetingUrl) { mutableStateOf(standup.meetingUrl.orEmpty()) }
    val dirty = MeetingLinkForm.isDirty(draft, standup.meetingUrl)

    SectionCard(
        title = "Meeting link",
        description = "Give the team a one-click way into the call after reading the standup.",
    ) {
        Column(modifier = Modifier.fillMaxWidth().gap(Spacing.lg)) {
            FormRow(label = "Call link", hint = MeetingLinkForm.HINT) {
                TextInput(
                    value = draft,
                    onValueChange = { draft = it },
                    type = InputType.Url,
                    placeholder = MeetingLinkForm.PLACEHOLDER,
                    ariaLabel = "Call link",
                    error = MeetingLinkForm.error(draft),
                    disabled = inFlight,
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth().gap(Spacing.sm),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Button(
                    label = "Reset",
                    variant = ButtonVariant.Ghost,
                    enabled = dirty && !inFlight,
                    onClick = { draft = standup.meetingUrl.orEmpty() },
                )
                Button(
                    label = if (inFlight) "Saving…" else "Save",
                    variant = ButtonVariant.Primary,
                    enabled = MeetingLinkForm.canSave(draft, standup.meetingUrl) && !inFlight,
                    onClick = { onSave(MeetingLinkForm.request(draft)) },
                )
            }
        }
    }
}
